import { render, staticRenderFns } from "./CompanyCard.vue?vue&type=template&id=692f1a19&scoped=true&"
import script from "./CompanyCard.vue?vue&type=script&lang=ts&"
export * from "./CompanyCard.vue?vue&type=script&lang=ts&"
import style0 from "./CompanyCard.vue?vue&type=style&index=0&id=692f1a19&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "692f1a19",
  null
  
)

export default component.exports